import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { RiBarcodeFill } from 'react-icons/ri';
import { ButtonRow, FormStepper, FormInput, useTrackedFormik, Hidden } from '@omnigenbiodata/ui';

import InnerLayout from '../../../../layout/Inner';
import {
  MESSAGES,
  SAMPLE_BARCODE_LENGTH,
  SAMPLE_BARCODE_REGEX,
  SAMPLE_STEPS,
} from '../../../../core/constants/forms.constant';
import ROUTES from '../../../../core/constants/routes.constant';

import { useAppDispatch, useAppSelector } from '../../../../store';
import { stepForward } from '../../../../store/samples';
import { formValueSelector } from '../../../../store/samples/selectors';

const validationSchema = yup.object({
  wholeBloodBarcode: yup
    .string()
    .oneOf([yup.ref('serumBloodBarcode')], MESSAGES.barcodeMismatch)
    .required(MESSAGES.barcodeRequired)
    .matches(SAMPLE_BARCODE_REGEX, MESSAGES.barcodeFormat)
    .min(SAMPLE_BARCODE_LENGTH, MESSAGES.barcodeLength)
    .max(SAMPLE_BARCODE_LENGTH, MESSAGES.barcodeLength),
});

function WholeBloodScan() {
  const navigateTo = useNavigate();
  const dispatch = useAppDispatch();
  const values = useAppSelector(formValueSelector);
  const formik = useTrackedFormik(
    {
      initialValues: {
        wholeBloodBarcode: '',
        ...values,
      },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        dispatch(stepForward(values));
        navigateTo(ROUTES.samplesPlasma1);
      },
    },
    'samples-whole-scan',
  );

  return (
    <InnerLayout>
      <form onSubmit={formik.handleSubmit}>
        <Box my={3}>
          <FormStepper steps={SAMPLE_STEPS} activeStep={1} />
        </Box>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Whole Blood Sample Collection
        </Typography>

        <Typography paragraph variant="body1" align="center">
          Following standardised procedures collect the blood sample using the LAVENDER capped tube and scan the barcode
          using the attachable barcode scanner.
        </Typography>

        <Grid container spacing={2}>
          <Hidden smDown>
            <Grid item md={2} />
          </Hidden>
          <Grid item xs={12} md={8}>
            <Box mb={2}>
              <img
                src="/images/tubes/edta.png"
                alt=""
                style={{
                  margin: '0 auto',
                  display: 'block',
                  maxWidth: '100%',
                }}
              />
            </Box>
            <Box mb={8}>
              <FormInput
                autoFocus
                error={formik.errors.wholeBloodBarcode}
                name="wholeBloodBarcode"
                label="Whole Blood Sample Barcode"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Scan barcode"
                touched={formik.touched.wholeBloodBarcode}
                value={formik.values.wholeBloodBarcode}
                startAdornment={<RiBarcodeFill fontSize="large" />}
              />
            </Box>
          </Grid>
        </Grid>

        <ButtonRow buttonSize="large" forwardColor="primary" />
      </form>
    </InnerLayout>
  );
}

export default WholeBloodScan;
